import styled, { css } from 'styled-components';

const ShowMore = styled.div(
  ({ numberOfLines }) => css`
    .show-more {
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${numberOfLines};
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `
);

export { ShowMore };
